import {createContext} from 'react';

export const TouchDeviceContext = createContext<boolean | undefined>(undefined);
